export const API_CONSTANTS = {
    LOGIN: "users/sign_in",
    REGISTER: "users",
    LOGOUT: "users/sign_out",
    FORGOT_PASSWORD: "users/password",
    RESET_PASSWORD: "users/password",

    // Registration OTP
    SEND_REGISTRATION_OTP: "api/v1/user_dashboard/send_registration_otp",
    VERIFY_REGISTRATION_OTP: "api/v1/user_dashboard/verify_registration_otp",
    RESEND_REGISTRATION_OTP: "api/v1/user_dashboard/resend_registration_otp",

    // Admin use
    COMMON_CATEGORIES_URL: "api/v1/categories",
    COMMON_SUB_CATEGORIES_URL: "api/v1/sub_categories",
    COMMON_PRODUCTS_URL: "api/v1/products",
    COMMON_INVENTORY_URL: "api/v1/inventories",
    COMMON_ORDER_URL: "api/v1/orders",
    COMMON_REPORT_URL: "api/v1/reports",
    COMMON_CUSTOMERS_URL: "api/v1/users",
    COMMON_ADRESESS_URL: "api/v1/addresses",
    COMMON_ADMIN_DASHBOARD_URL: "api/v1/dashboard",
    COMMON_BLOGS_URL: "api/v1/blogs",
    COMMON_PRODUCT_REVIEW_URL: "api/v1/product_reviews",
    COMMON_SUBSCIBER_URL: "api/v1/subscribers",
    COMMON_CUSTOMER_ENQUIRY_URL: "api/v1/contact_details",
    COMMON_NOTIFICATIONS_URL: "api/v1/notifications",
    COMMON_HOME_SECTIONS_URL: "api/v1/home_sections",
    COMMON_MASTERS_URL: "api/v1/masters",
    COMMON_SETTINGS_URL: "api/v1/settings",
    COMMON_WAREHOUSES_URL: "api/v1/warehouses",

    // Company info (multi-tenant)
    COMPANY_INFO_URL: "user_dashboard/company_info",

    // General use
    BLOGS_URL: "api/v1/user_dashboard/latest_blogs",
    SNACK_RANGE_URL: "api/v1/user_dashboard/snacks_category",
    SPECIALITY_CATEGORY_URL: "api/v1/user_dashboard/speciality_category",
    GIFTING_CATEGORY_URL: "api/v1/user_dashboard/gifting_category",
    ALL_CATEGORY_URL: "api/v1/user_dashboard/all_categories",
    ALL_PRODUCTS_URL: "api/v1/user_dashboard/all_active_products",
    BESTSELLING_URL: "api/v1/user_dashboard/bestselling",
    BESTSELLING_BY_CATEGORY_URL: "api/v1/user_dashboard/bestselling_by_category",
    ALL_PRODUCT_URL: "api/v1/products/active_product",
    MENU_LIST_URL: "api/v1/user_dashboard/nav_menu_list",
    GET_PRODUCT_BY_SUBCATEGORY_ID_URL: "api/v1/user_dashboard/get_products_by_subcategory",
    ALL_SUB_CATEGORY_URL: "api/v1/user_dashboard/all_sub_categories",
    PRODUCT_REVIEW_URL: "api/v1/user_dashboard/add_user_review",
    PRODUCT_REVIEW_BY_ID_URL: "api/v1/user_dashboard/get_product_review_by_id",
    SUBSCRIBE_USER_BY_MAIL_URL: "api/v1/user_dashboard/subscribe_user_by_email",
    SEND_PHONE_OTP_URL: "api/v1/user_dashboard/send_user_otp",
    VERIFY_PHONE_OTP_URL: "api/v1/user_dashboard/verify_user_otp",
    SEND_LOGIN_OTP_URL: "api/v1/user_dashboard/send_login_otp",
    VERIFY_LOGIN_OTP_URL: "api/v1/user_dashboard/verify_login_otp",
    RESET_PASSWORD_BY_OTP_URL: "api/v1/user_dashboard/reset_password_by_otp",
    CHANGE_PASSWORD_URL: "api/v1/users/change_password",
    DELIVERY_UPDATE_LOCATION: "delivery_agent/update_location",
    DELIVERY_TRACK_ORDER: "delivery_agent/track",
    SAVE_PUSH_SUBSCRIPTION: "save_push_subscription",
    GOOGLE_AUTH: "api/v1/users/google_signin",
    PAYMENT_INTENT_CREATE: "api/v1/payment_transactions/create_payment_intent",
    PAYMENT_INTENT_VERIFY: "api/v1/payment_transactions/verify_payment",
    ADD_CONTACT_DETAILS: "api/v1/user_dashboard/add_contact_details",
    GET_ALL_SUBCATEGORY_BY_CATEGORY_NAME_URL: "api/v1/user_dashboard/get_subcategories_by_category_name",
    GET_PRODUCT_BY_CATEGORY_NAME_URL: "api/v1/user_dashboard/get_products_by_category_name",
    GET_PRODUCT_BY_SUB_CATEGORY_NAME_URL: "api/v1/user_dashboard/get_products_by_subcategory_name",
    SEARCH_PRODUCTS_URL: "api/v1/user_dashboard/search_products",
    HOME_SECTIONS_URL: "api/v1/user_dashboard/home_sections",
    HOMEPAGE_DATA_URL: "api/v1/user_dashboard/homepage_data",
    CATEGORY_PAGE_DATA_URL: "api/v1/user_dashboard/category_page_data",

    // Returns & Refunds API endpoints
    RETURN_REQUEST_URL: "api/v1/orders",       // POST /orders/{orderId}/return
    GET_RETURN_URL: "api/v1/returns",           // GET /returns/{returnId}
    GET_USER_RETURNS_URL: "api/v1/users",       // GET /users/{userId}/returns

    // Order Feedback / Rating
    ORDER_FEEDBACK_URL: "api/v1/orders/feedback",  // POST /orders/feedback, GET /orders/feedback/{orderId}

    // Cart API endpoints
    CART_URL: "api/v1/cart",
    CART_ADD_URL: "api/v1/cart/add",
    CART_REMOVE_URL: "api/v1/cart/remove",
    CART_UPDATE_QUANTITY_URL: "api/v1/cart/update_quantity",
    CART_CLEAR_URL: "api/v1/cart/clear",
    CART_SUMMARY_URL: "api/v1/cart/summary",
    CART_APPLICABLE_DISCOUNTS_URL: "api/v1/cart/applicable_discounts",

    // Coupons API endpoints
    COUPONS_URL: "api/v1/coupons",

    // Home Sections API endpoints (Admin)
    HOME_SECTIONS: "api/v1/home_sections",

    // Banners API endpoints
    BANNERS_GET: "api/v1/user_dashboard/banners",
    BANNERS_UPLOAD: "api/v1/admin/banners/upload",
    BANNERS_DELETE: "api/v1/admin/banners",

    // Discounts API endpoints (Admin)
    DISCOUNTS: "api/v1/discounts",

    // Masters API endpoints
    MASTERS: {
        LIST: "api/v1/masters",
        CREATE: "api/v1/masters",
        SHOW: "api/v1/masters/:id",
        UPDATE: "api/v1/masters/:id",
        DELETE: "api/v1/masters/:id",
        FILTER: "api/v1/masters/filter",
        TYPES: "api/v1/masters/types",
        BY_TYPE: "api/v1/masters/by_type/:master_type",
        REORDER: "api/v1/masters/reorder"
    },

    // Settings API endpoints
    SETTINGS: {
        LIST: "api/v1/settings",
        SHOW: "api/v1/settings/:id",
        UPDATE: "api/v1/settings/:id",
        THEME_COLORS: "api/v1/settings/theme_colors"
    },

    // Ecommerce admin settings (Google Maps key, etc.)
    ECOMMERCE_ADMIN_SETTINGS: "api/v1/ecommerce/admin/settings",

    // Wallet API endpoints (admin — DukanSarthi token required)
    WALLET_ADMIN_SETTINGS: "api/v1/ecommerceadmin/wallet/settings",
    WALLET_ADMIN_BONUS: "api/v1/ecommerceadmin/wallet/bonus",
    WALLET_ADMIN_USERS: "api/v1/ecommerceadmin/wallet/users",

    // Wallet API endpoints (ecommerce user)
    WALLET_SETTINGS: "wallet/settings",
    WALLET_BALANCE: "wallet/balance",

    // Razorpay payment endpoints
    PAYMENT_CREATE_ORDER: "payment/create_order",
    PAYMENT_VERIFY: "payment/verify",
}